import m from "../../geodata/es2015/mexicoHigh";
window.am4geodata_mexicoHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/mexicoHigh.js
// module id = null
// module chunks = 